import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/deploy-logs.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-production',
  templateUrl: './production.component.html',
  styleUrls: ['./production.component.scss']
})
export class ProductionComponent implements OnInit {
  productionScripts = [
    {name: 'Take RDS Prod Snapshot', link: '/prod-rds-snapshot'},
    {name: 'Download API Server production.log file', link: '/get-prod-api-logs'},
    {name: 'Download API Server sidekiq.log file', link: '/get-prod-api-sidekiq-logs'},
    {name: 'Generate Lambda Report', link: '/generate-lambda-report'},
    {name: 'Get Deploy Logs', link: '/get-production-deploy-logs'},
    {name: 'Generate DMS report', link: '/generate-dms-report'},
    {name: 'Trigger CDK Poll Pipeline', link: '/trigger-cdk-poll-pipeline'},
    {name: 'Get Web Build Logs', link: '/get-build-logs?name=bizzycar-production-web-v2'},
  ];

  showResponseModal = false;
  currentEndpoint = '';
  currentScriptName = '';
  responseData: SafeHtml = '';
  isLoading = false;
  error = '';

  constructor(
    private apiService: ApiService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
  }

  executeScript(script: any) {
    this.currentEndpoint = script.link;
    this.currentScriptName = script.name;
    this.showResponseModal = true;
    this.isLoading = true;
    this.error = '';
    this.responseData = '';

    this.apiService.makeApiCall(this.currentEndpoint).subscribe({
      next: (response) => {
        this.responseData = this.sanitizer.bypassSecurityTrustHtml(response);
        this.isLoading = false;
      },
      error: (err) => {
        this.error = 'Failed to execute script. Please try logging out and back in. Check slack #aws-chatbot to confirm the script didnt run before retrying';
        this.isLoading = false;
      }
    });
  }

  closeResponseModal() {
    this.showResponseModal = false;
    this.currentEndpoint = '';
    this.currentScriptName = '';
    this.responseData = '';
    this.error = '';
  }

  copyResponse() {
    // Get the text content from the response div
    const responseElement = document.querySelector('.response-content div');
    if (responseElement) {
      const textToCopy = responseElement.textContent || '';
      if ((navigator as any).clipboard && window.isSecureContext) {
        (navigator as any).clipboard.writeText(textToCopy).then(() => {
          // Optional: Show a success message
          const copyButton = document.querySelector('.copy-button');
          if (copyButton) {
            const originalText = copyButton.innerHTML;
            copyButton.innerHTML = '<span class="copy-icon">✓</span> Copied!';
            setTimeout(() => {
              copyButton.innerHTML = originalText;
            }, 2000);
          }
        }).catch(err => {
          console.error('Failed to copy text: ', err);
        });
      } else {
        // Fallback for non-secure contexts
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          const copyButton = document.querySelector('.copy-button');
          if (copyButton) {
            const originalText = copyButton.innerHTML;
            copyButton.innerHTML = '<span class="copy-icon">✓</span> Copied!';
            setTimeout(() => {
              copyButton.innerHTML = originalText;
            }, 2000);
          }
        } catch (err) {
          console.error('Failed to copy text: ', err);
        }
        textArea.remove();
      }
    }
  }

  updateAPIBranchName(name: string) {
    this.currentEndpoint = `/update-production-api-branch?name=${name}`;
    this.currentScriptName = 'Update API Branch Name';
    this.executeScript({ link: this.currentEndpoint, name: this.currentScriptName });
  }

  updateWEBBranchName(name: string) {
    this.currentEndpoint = `/update-production-web-branch-name?name=${name}`;
    this.currentScriptName = 'Update WEB Branch Name';
    this.executeScript({ link: this.currentEndpoint, name: this.currentScriptName });
  }

  runCommand(command: string) {
    this.currentEndpoint = `/run-command-on-production?name=${command}`;
    this.currentScriptName = 'Run Command';
    this.executeScript({ link: this.currentEndpoint, name: this.currentScriptName });
  }
}
